<template>
  <label
    class="lp-radio-wrapper"
    :class="[
      isChecked && `lp-radio-wrapper-${type}-checked`,
      `lp-radio-wrapper-${type}`,
      disabled && 'lp-radio-wrapper-disabled',
      card && 'radio-card',
    ]"
  >
    <input
      class="lp-radio-input"
      :disabled="disabled"
      type="radio"
      :checked="isChecked"
      :value="modelValue"
      v-bind="$attrs"
      @change="check"
    />
    <span :class="['lp-radio-border', pulse && !disabled && 'pulse']">
      <span class="lp-radio-circle"></span>
    </span>
    <lp-icon v-if="icon && card" :name="icon" />
    <span class="lp-radio-label-group">
      <span
        v-if="label && !$slots.default"
        class="lp-radio-label"
        :class="[disabled && 'lp-radio-label-disabled']"
      >
        {{ label }}
      </span>
      <span
        v-if="subLabel && !$slots.sublabel"
        class="lp-radio-label lp-radio-label-sub"
        :class="[disabled && 'lp-radio-label-disabled']"
      >
        {{ subLabel }}
      </span>

      <span
        v-if="$slots.default"
        class="lp-radio-label"
        :class="[disabled && 'lp-radio-label-disabled']"
      >
        <slot></slot>
      </span>
      <span
        v-if="$slots.sublabel"
        class="lp-radio-label lp-radio-label-sub"
        :class="[disabled && 'lp-radio-label-disabled']"
      >
        <slot name="sublabel"></slot>
      </span>
    </span>
  </label>
</template>

<script lang="ts">
import { Colors } from '@/models/enums'
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'lp-radio',
  inheritAttrs: false,
  props: {
    type: {
      default: Colors.PRIMARY,
      type: String,
      validator: (value: Colors) =>
        [
          Colors.NEUTRAL,
          Colors.PRIMARY,
          Colors.SECONDARY,
          Colors.SUCCESS,
          Colors.DANGER,
          Colors.ERROR,
          Colors.WARNING,
          Colors.BLACK,
        ].includes(value),
    },
    label: { type: String },
    subLabel: { type: String },
    pulse: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    value: {},
    card: { type: Boolean, default: false },
    icon: { type: String, default: null },
  },
  setup(props, { emit }) {
    function check() {
      if (props.disabled) {
        return
      }
      emit('update:modelValue', props.value)
    }

    const isChecked = computed(() => props.modelValue === props.value)
    return { check, isChecked }
  },
})
</script>
